import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import * as Validator from "../../../../../util/validation";
import { AppState } from "../../../../store/app_state";

import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import ErrorText from "../../../../common/atom/text/error_text";
import {
  PasswordFormFieldWrapper,
  PasswordIconButton,
} from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IProps extends InjectedFormProps<FormData, {}> {}

interface IState {
  showPassword: boolean;
  showPassword2: boolean;
  showPassword3: boolean;
}

export class CustomerMypageMainPasswordForm extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      showPassword: false,
      showPassword2: false,
      showPassword3: false,
    };
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    return (
      <React.Fragment>
        <form name="CustomerMypageMainPasswordForm" onSubmit={handleSubmit}>
          <PasswordFormFieldWrapper>
            <Field
              label="パスワード"
              placeholder="入力してください"
              name="currentPassword"
              component={FormGroupInputConnectRf}
              type={this.state.showPassword ? "text" : "password"}
              validate={[Validator.required]}
              require={true}
            />
            <PasswordIconButton
              type="button"
              onClick={() => {
                this.setState((prevState) => ({
                  showPassword: !prevState.showPassword,
                }));
              }}
            >
              {this.state.showPassword ? (
                <i className="fas fa-eye-slash" />
              ) : (
                <i className="fas fa-eye" />
              )}
            </PasswordIconButton>
          </PasswordFormFieldWrapper>
          <PasswordFormFieldWrapper>
            <Field
              label="新しいパスワード"
              placeholder="入力してください"
              name="password"
              component={FormGroupInputConnectRf}
              type={this.state.showPassword2 ? "text" : "password"}
              validate={[
                Validator.password,
                Validator.passwordCount,
                Validator.required,
              ]}
              require={true}
            />
            <PasswordIconButton
              type="button"
              onClick={() => {
                this.setState((prevState) => ({
                  showPassword2: !prevState.showPassword2,
                }));
              }}
            >
              {this.state.showPassword2 ? (
                <i className="fas fa-eye-slash" />
              ) : (
                <i className="fas fa-eye" />
              )}
            </PasswordIconButton>
          </PasswordFormFieldWrapper>
          <PasswordFormFieldWrapper>
            <Field
              label="新しいパスワード(確認)"
              placeholder="入力してください"
              name="confirm"
              component={FormGroupInputConnectRf}
              type={this.state.showPassword3 ? "text" : "password"}
              validate={[Validator.confirmPass, Validator.required]}
              require={true}
            />
            <PasswordIconButton
              type="button"
              onClick={() => {
                this.setState((prevState) => ({
                  showPassword3: !prevState.showPassword3,
                }));
              }}
            >
              {this.state.showPassword3 ? (
                <i className="fas fa-eye-slash" />
              ) : (
                <i className="fas fa-eye" />
              )}
            </PasswordIconButton>
          </PasswordFormFieldWrapper>

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <BtnLinkCancelSmall to="/customer/mypage/customer">
                キャンセル
              </BtnLinkCancelSmall>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name="CustomerMypageMainPasswordForm-submit"
              type="submit"
              disabled={pristine || submitting || invalid}
            >
              パスワードを再設定する
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "CustomerMypageMainPasswordForm",
  validate,
})(
  connect(mapStateToProps, mapDispatchToProps)(CustomerMypageMainPasswordForm)
);



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/password_update/customer_mypage_main_password_form.tsx